module.exports = __webpack_public_path__ + "img/unavailable.d5e96ae9.svg";